import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";
import PolicyContent from "@/components/PolicyContent";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "Which lash set should I choose?", a: "If you're unsure, choose the look you're drawn to and we'll refine it in studio. Classic is natural and defined, volume is fuller and darker, and mega volume is the most dramatic." },
  { q: "Can I book if I'm unsure what style I want?", a: "Absolutely. Tell me the look you love and I'll help choose a style that suits your eye shape, natural lashes and features." },
  { q: "How much is the deposit?", a: "A 50% deposit is required to secure your appointment. You can also choose to pay the full amount online." },
  { q: "Can I pay in full?", a: "Yes. You can pay the full appointment amount online at checkout, so there's nothing left to pay in studio." },
  { q: "Where are you located?", a: "The studio is in Moonee Ponds, Melbourne. The exact address and arrival instructions are provided after booking." },
  { q: "How long is my appointment?", a: "It depends on the service — the exact duration is shown when you choose your service during booking." },
  { q: "What is your cancellation policy?", a: "A cancellation made with less than 48 hours notice, and no-shows, will result in the loss of your retainer (deposit). With 48+ hours notice your deposit can be transferred to a new booking where possible. To cancel or reschedule, please message us on Instagram @slavic.lashes.brows." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq" className="bg-[#FAF8F5] text-[#1C1917] py-24 lg:py-36">
      <div className="max-w-[1000px] mx-auto px-5 sm:px-10">
        <Reveal className="mb-12">
          <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Good to Know</span>
          <h2 className="font-serif text-6xl sm:text-8xl font-medium leading-[0.9] tracking-tight mt-4">FAQ</h2>
        </Reveal>
        <Reveal>
          <Accordion type="single" collapsible className="w-full space-y-3">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border border-[#1C1917]/10 rounded-2xl bg-white px-5 sm:px-6">
                <AccordionTrigger className="text-left font-serif text-2xl sm:text-3xl font-medium hover:text-[#C5B382] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#1C1917]/60 text-base leading-relaxed pb-6 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-10">
          <div id="policy" data-testid="faq-policy" className="border border-[#1C1917]/10 rounded-2xl bg-white p-6 sm:p-8">
            <span className="text-[#7A8B7B] text-[11px] tracking-[0.35em] uppercase font-semibold">Please Read Before Booking</span>
            <h3 className="font-serif text-3xl sm:text-4xl font-medium mt-3 mb-6">Booking Policy</h3>
            <PolicyContent />
            <Link to="/policy" data-testid="faq-policy-link" className="inline-block mt-7 text-[#C5B382] text-xs font-semibold tracking-[0.2em] uppercase hover:underline">
              View full policy page →
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
